/**
 * Parte una frase en tres para poder resaltar un trozo del medio.
 *
 * ── Por qué esto existe y no tres props ──────────────────────────────
 * La tentación en cada titular es `<Titulo antes="…" resalte="…"
 * despues="…">`. Eso obliga a partir la frase en el archivo de
 * traducción, y una frase partida no se puede traducir: en inglés la
 * palabra resaltada cae en otra posición y el traductor recibe tres
 * cachos sin contexto.
 *
 * Aquí llega la frase COMPLETA —una sola clave, traducible— y se busca
 * dentro qué resaltar. Si el trozo no aparece (porque la traducción lo
 * escribió distinto), la frase se pinta ENTERA y sin resalte, que es
 * degradar bien: se pierde un énfasis, no el titular.
 *
 * Vive en `shared/lib` y no dentro de un componente porque ya lo usan dos
 * titulares distintos —el del bloque de cierre (`CtaHeading`) y el de las
 * portadas de página (`PageHeroTitle`)— y no tienen nada más en común: uno
 * es un `<h2>` blanco sobre tinta y el otro un `<h1>` oscuro sobre crema.
 * Lo compartido es la REGLA, no el estilo.
 */
export interface HighlightParts {
  before: string;
  /** `null` = no hay nada que resaltar; pinta `before` y ya está. */
  highlight: string | null;
  after: string;
}

export function splitHighlight(text: string, highlight?: string): HighlightParts {
  const index = highlight ? text.indexOf(highlight) : -1;

  if (!highlight || index === -1) {
    return { before: text, highlight: null, after: "" };
  }

  return {
    before: text.slice(0, index),
    highlight,
    after: text.slice(index + highlight.length),
  };
}
